import type { MessagingHistoryColumn } from './messagingHistory.types';
import type { MessagingPageProps } from './messagingHistory.types';

export const getMessagingHistoryColumns = (
  status: MessagingPageProps['status']
): MessagingHistoryColumn[] => {
  const baseColumns: MessagingHistoryColumn[] = [
    {
      Header: 'Name',
      accessor: 'name',
      style: {
        fontFamily: 'Inter Bold, sans-serif',

        minWidth: '150px',
        width: '250px',
      },
    },
    {
      Header: 'Message Type',
      accessor: 'messageType',
      style: {
        minWidth: '100px',
        width: '200px',
        textAlign: 'center',
      },
    },
    {
      Header: 'Content',
      accessor: 'content',
      style: {
        minWidth: '200px',
        width: '350px',
      },
    },
    {
      Header: 'Recipients',
      accessor: 'recipients',
      style: {
        minWidth: '70px',
        width: '200px',
        textAlign: 'center',
      },
    },
  ];

  if (status === 'scheduled') {
    baseColumns.push(
      {
        Header: 'Scheduled At',
        accessor: 'scheduledAt',
        style: {
          minWidth: '120px',
          width: '200px',
        },
      },
      {
        Header: '',
        accessor: 'cancelAction',
        style: { minWidth: '100px', width: '150px', wordBreak: 'break-word' },
      }
    );
  } else {
    baseColumns.push(
      {
        Header: 'Status',
        accessor: 'status',
        style: {
          minWidth: '100px',
          width: '250px',
        },
      },
      {
        Header: 'Errors',
        accessor: 'errors',
        style: {
          minWidth: '70px',
          width: '200px',
          textAlign: 'center',
        },
      },
      {
        Header: 'Completed At',
        accessor: 'completedAt',
        style: {
          minWidth: '150px',
          width: '200px',
        },
      }
    );
  }
  baseColumns.push({
    Header: '',
    accessor: 'moreInfo',
    style: {
      minWidth: '50px',
      width: '50px',
    },
  });
  return baseColumns;
};
